import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import quoteDetailAPICallResponseMaker from "src/service/reponseMaker/quoteDetailAPICallResponseMaker";
import { isObject, isString } from "underscore";
import produceClone from "../../../helper/produceClone";
import System from "src/helper/system";
import liveAuth from "src/helper/liveAuth";
import QuoteRepository from "src/repository/QuoteRepository";

const initialState = new quoteDetailAPICallResponseMaker().defaultValue();

export const getLineItemsDetail = createAsyncThunk('quote_detail_get_line_item_details', async (params) => {
   
    return await new QuoteRepository().getLineItemsDetail(params)
});

const avUserInfo = liveAuth.getAvUserInfo()
const metaData = avUserInfo?.account;

const setAllToLocalStorage = (data) => {
    data = produceClone(data);
    sessionStorage.setItem(System.storageName.QUOTE_CART_ACTIVE_SESSION, metaData ? metaData?.accountNumber : metaData)
    sessionStorage.setItem(System.storageName.QUOTE_CART_ACTIVE_SESSION_SPEEDBOAT, JSON.stringify(data.cart_quote_active_session))
};

const getAllToLocalStorage = () => {
    const getMetaData = sessionStorage.getItem(System.storageName.QUOTE_CART_ACTIVE_SESSION);
    if (System.avUserInfoData.accountNumber === getMetaData) {
        let l_h = sessionStorage.getItem(System.storageName.QUOTE_CART_ACTIVE_SESSION_SPEEDBOAT)
        if (l_h && l_h !== 'undefined') {
            return JSON.parse(l_h);
        }
    } else {
        const data = initialState.cart_quote_active_session
        setAllToLocalStorage(data)
    }
    return initialState.cart_quote_active_session;
};

const slice = createSlice({
    name: "QuoteDetail",
    initialState: { ...initialState, ...{ cart_quote_active_session: getAllToLocalStorage() } },
    reducers: {
        toggle_quote_cart_line_item: {
            reducer: (state, action) => {
                let s = {};
                let p_d = action.payload.data;
                if (state.cart_quote_active_session[p_d.quoteNumber] !== undefined) {
                    s = state.cart_quote_active_session[p_d.quoteNumber];
                }
                if (s.records === undefined) {
                    s.records = {};
                }
                s.records[p_d.quoteLineNumber] = p_d;
                if (p_d.quantity_field_selected === undefined ||
                    p_d.quantity_field_selected === false) {
                    delete s.records[p_d.quoteLineNumber];
                }
                state.cart_quote_active_session[p_d.quoteNumber] = s;
                setAllToLocalStorage(state);
                return state;
            },
        },
        remove_all_quote_number_based_cart_quote_active_session: {
            reducer: (state, action) => {
                let p_d = action.payload.data;
                delete state.cart_quote_active_session[p_d.quoteNumber];
                setAllToLocalStorage(state)
                return state;
            },
        },
        destroy_cart_quote_active_session: {
            reducer: (state, action) => {
                state.cart_quote_active_session = initialState.cart_quote_active_session;
                setAllToLocalStorage(state)
                return state;
            },
        },
        remove_quote_cart_line_item: {
            reducer: (state, action) => {

                let s = {};
                let p_d = action.payload;
                if (state.cart_quote_active_session[p_d.quoteNumber] !== undefined) {
                    s = state.cart_quote_active_session[p_d.quoteNumber];
                }
                if (s.records === undefined) {
                    s.records = {};
                }
                if (s.records[p_d.quoteLineNumber] !== undefined) {
                    delete s.records[p_d.quoteLineNumber];
                }
                state.cart_quote_active_session[p_d.quoteNumber] = s;
                setAllToLocalStorage(state)
                return state;
            },
        },
        select_all_quantity: {
            reducer: (state, action) => {
                let s = {};
                let quoteNumber = action.payload.quoteNumber;
                if (state.cart_quote_active_session[quoteNumber] !== undefined) {
                    s = state.cart_quote_active_session[quoteNumber];
                }
                s.records = action.payload.list;
                state.cart_quote_active_session[quoteNumber] = s;
                setAllToLocalStorage(state);
                return state;
            },
        },
        set_schedule_date: {
            reducer: (state, action) => {
                let s = {};
                let p_d = action.payload;
                let quoteNumber = p_d.quoteNumber;
                if (state.cart_quote_active_session[quoteNumber] !== undefined) {
                    s = state.cart_quote_active_session[quoteNumber];
                }
                s.records[p_d.quoteLineNumber].scheduleDetails = p_d.shipmentDetails
                state.cart_quote_active_session[quoteNumber] = s;
                setAllToLocalStorage(state);
                return state;
            },

        },
        clear_all_line_items: {
            reducer: (state, action) => {
                state.line_items = new quoteDetailAPICallResponseMaker().defaultValue();
                return state;
            }
        }
    },
    extraReducers: {
        [getLineItemsDetail.fulfilled]: (state, { payload }) => {
            return merge_payload_to_state(state, payload);
        }
    },
});

function merge_payload_to_state(state, payload, from = "line_items") {
    let data = payload.data;

    if (state.line_items === undefined) {
        state.line_items = {};
    }
    if (state.line_items !== undefined && state.line_items[data.line_items_axios_fetch_slug] === undefined &&
        data.line_items_axios_fetch_slug !== false
    ) {
        state.line_items[data.line_items_axios_fetch_slug] = {
            count: 0
        };
    }
    if (data.line_items_axios_fetch_slug !== undefined && data.line_items_axios_fetch_slug) {
        state.line_items[data.line_items_axios_fetch_slug] = data.line_items[data.line_items_axios_fetch_slug];
    }
    if (data.line_items_axios_fetch_slug !== undefined && data.line_items_axios_fetch_slug === false &&
        isObject(data.line_items) && Object.entries(data.line_items).length > 0
    ) {
        Object.entries(data.line_items).map((v) => {
            if (state.line_items[v[0]] === undefined) {
                state.line_items[v[0]] = {
                    count: 0
                };
            }
            else {
                if (state.line_items[v[0]].count != v[1].count) {
                    state.line_items[v[0]] = v[1];
                }
            }
        })
    } else {
        // set count
        if (isObject(data.line_items) && Object.entries(data.line_items).length > 0 && state.line_items !== undefined && state.line_items[data.line_items_axios_fetch_slug]) {
            Object.entries(data.line_items).map((v) => {
                if (state.line_items[v[0]] === undefined) {
                    state.line_items[v[0]] = { count: 0 };
                } else {
                    if (state.line_items[v[0]].count != v[1].count) {
                        state.line_items[v[0]] = v[1];
                    }
                }
            })
        }
    }

    return state;
}

export let { toggle_quote_cart_line_item, destroy_cart_quote_active_session, remove_all_quote_number_based_cart_quote_active_session, remove_quote_cart_line_item, select_all_quantity, set_schedule_date,clear_all_line_items } = slice.actions;

export default slice.reducer;
